export default __webpack_public_path__ + "static/media/email.203243df.svg";